<template>
  <button
    v-if="$hasPermission('MANAGE_SHARED_MODULES')"
    class="button is-small share-button"
    :class="buttonClass"
    :disabled="isLoading"
    @click="handleClick">
    {{ buttonText }}
  </button>
</template>
<script>

  export default {
    props: {
      dashboardModule: {
        type: Object,
        required: true,
      },
      dashboardKey: {
        type: String,
        required: true,
      },
      sharedModuleId: {
        type: String,
        default: undefined,
      },
    },
    data () {
      return {
        isLoading: false,
      }
    },
    computed: {
      isShared () {
        return this.sharedModuleId != null
      },
      buttonText () {
        if (this.isLoading) return this.isShared ? 'Unsharing...' : 'Sharing...'
        return this.isShared ? 'Unshare with Claude' : 'Share with Claude'
      },
      buttonClass () {
        return {
          'is-loading disabled': this.isLoading,
          'shared': this.isShared,
          'not-shared': !this.isShared,
        }
      },
    },
    methods: {
      async handleClick () {
        if (this.isLoading) return
        this.isLoading = true
        try {
          if (this.isShared) {
            await this.unshare()
          } else {
            await this.share()
          }
        } finally {
          this.isLoading = false
        }
      },

      async share () {
        const result = await this.$apis.companyConfigs.shareModule(
          this.dashboardKey,
          this.dashboardModule.key
        )
        if (result?.id) {
          this.$emit('shared', result.id)
          this.$buefy.toast.open({
            message: 'Module shared with Claude',
            type: 'is-success',
          })
        } else {
          this.$buefy.toast.open({
            message: 'Failed to share module',
            type: 'is-danger',
          })
        }
      },

      async unshare () {
        const result = await this.$apis.companyConfigs.unshareModule(
          this.sharedModuleId
        )
        if (result?.success) {
          this.$emit('unshared')
          this.$buefy.toast.open({
            message: 'Module unshared from Claude',
            type: 'is-success',
          })
        } else {
          this.$buefy.toast.open({
            message: 'Failed to unshare module',
            type: 'is-danger',
          })
        }
      },
    },
  }
</script>
<style scoped lang="scss">
.share-button {
  box-shadow: none !important;

  &.not-shared {
    background: #5b21b6;
    color: #fff;
    border: 1px solid #7c3aed !important;

    &:hover {
      background: #4c1d95;
    }
  }

  &.shared {
    background: #991b1b;
    color: #fca5a5;
    border: 1px solid #dc2626 !important;

    &:hover {
      background: #7f1d1d;
    }
  }
}
</style>
